import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "ta-c" };
import { routeName } from '@/constants/routeName';
import dateFormatType from '@/constants/dateFormatType';
import { pStore } from '@/pinia';
import { prevData } from '@/pinia/barogoNotice';
import { isTodayTextColor, formatDate, } from '@/utils';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Item',
    props: {
        item: {}
    },
    setup(__props) {
        const props = __props;
        /**
         * 링크 경로
         */
        const to = () => {
            const { id } = props.item;
            return {
                name: routeName.BAROGO_NOTICE_DETAIL,
                params: {
                    barogoNoticeId: id,
                },
            };
        };
        /**
         * 링크 클릭 핸들러
         */
        const handleClickLink = () => {
            // 현재 페이지네이션 번호 저장
            prevData.pageNumber = pStore.piniaBarogoNotice.filterOption.pageNumber;
        };
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("tr", null, [
                _createElementVNode("td", null, _toDisplayString(props.item.id), 1 /* TEXT */),
                _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                        class: "cy-link",
                        to: to(),
                        onClick: _cache[0] || (_cache[0] = ($event) => (handleClickLink()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.item.title), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["to"])
                ]),
                _createElementVNode("td", _hoisted_1, [
                    _createElementVNode("span", {
                        class: _normalizeClass(_unref(isTodayTextColor)(props.item.createdAt))
                    }, _toDisplayString(_unref(formatDate)(props.item.createdAt, _unref(dateFormatType).FULL_DATE)), 3 /* TEXT, CLASS */)
                ])
            ]));
        };
    }
});
